export default __webpack_public_path__ + "static/char-s-45-ko-3855f14a678c44e63d898c5c2465a9d5.webp";